module.exports = __webpack_public_path__ + "assets/img/plan1-2.54d71a16.png";